import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
import ProductImage from '../ProductImage';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'center',
      flexGrow: '1'
    },
    image: _defineProperty({
      display: 'block',
      maxWidth: '100%',
      maxHeight: '100%',
      verticalAlign: 'middle'
    }, theme.breakpoints.down('xs'), {
      // width: 'unset',
      maxWidth: '100%',
      maxHeight: '100%' // height: 250,

    }),
    insideBottomLeft: {
      bottom: 0,
      left: 0
    },
    insideBottomRight: {
      bottom: 0,
      right: 0
    },
    insideContent: {
      position: 'absolute'
    },
    insideTopLeft: {
      left: 0,
      top: 0
    },
    insideTopRight: {
      top: 0,
      right: 0
    },
    left: {
      flex: 0,
      display: 'flex',
      flexDirection: 'column'
    },
    middle: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      position: 'relative',
      flexGrow: '1'
    },
    right: {
      flex: 0,
      display: 'flex',
      flexDirection: 'column'
    }
  };
}, {
  name: 'SxComProductImageDecorated'
});

function ProductImageDecorated(_ref) {
  var active = _ref.active,
      adornmentAsideLeft = _ref.adornmentAsideLeft,
      adornmentAsideRight = _ref.adornmentAsideRight,
      adornmentInsideBottomLeft = _ref.adornmentInsideBottomLeft,
      adornmentInsideBottomRight = _ref.adornmentInsideBottomRight,
      adornmentInsideTopLeft = _ref.adornmentInsideTopLeft,
      adornmentInsideTopRight = _ref.adornmentInsideTopRight,
      alt = _ref.alt,
      pClasses = _ref.classes,
      className = _ref.className,
      mediaTypeComponents = _ref.mediaTypeComponents,
      ProductImageProps = _ref.ProductImageProps,
      shape = _ref.shape,
      shrink = _ref.shrink,
      size = _ref.size,
      src = _ref.src,
      stream = _ref.stream,
      type = _ref.type,
      rest = _objectWithoutProperties(_ref, ["active", "adornmentAsideLeft", "adornmentAsideRight", "adornmentInsideBottomLeft", "adornmentInsideBottomRight", "adornmentInsideTopLeft", "adornmentInsideTopRight", "alt", "classes", "className", "mediaTypeComponents", "ProductImageProps", "shape", "shrink", "size", "src", "stream", "type"]);

  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, pickHTMLProps(rest), {
    className: clsx(classes.root, className)
  }), adornmentAsideLeft && /*#__PURE__*/React.createElement("div", {
    className: classes.left
  }, adornmentAsideLeft), /*#__PURE__*/React.createElement("div", {
    className: classes.middle
  }, /*#__PURE__*/React.createElement(ProductImage, _extends({
    active: active,
    alt: alt,
    src: src,
    stream: stream,
    type: type,
    className: classes.image,
    shape: shape,
    shrink: shrink,
    size: size,
    mediaTypeComponents: mediaTypeComponents
  }, ProductImageProps)), adornmentInsideTopLeft && /*#__PURE__*/React.createElement("div", {
    className: clsx(classes.insideContent, classes.insideTopLeft)
  }, adornmentInsideTopLeft), adornmentInsideTopRight && /*#__PURE__*/React.createElement("div", {
    className: clsx(classes.insideContent, classes.insideTopRight)
  }, adornmentInsideTopRight), adornmentInsideBottomLeft && /*#__PURE__*/React.createElement("div", {
    className: clsx(classes.insideContent, classes.insideBottomLeft)
  }, adornmentInsideBottomLeft), adornmentInsideBottomRight && /*#__PURE__*/React.createElement("div", {
    className: clsx(classes.insideContent, classes.insideBottomRight)
  }, adornmentInsideBottomRight)), adornmentAsideRight && /*#__PURE__*/React.createElement("div", {
    className: classes.right
  }, adornmentAsideRight));
}

ProductImageDecorated.propTypes = {
  active: PropTypes.bool,
  adornmentAsideLeft: PropTypes.node,
  adornmentAsideRight: PropTypes.node,
  adornmentInsideBottomLeft: PropTypes.node,
  adornmentInsideBottomRight: PropTypes.node,
  adornmentInsideTopLeft: PropTypes.node,
  adornmentInsideTopRight: PropTypes.node,
  alt: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.shape({
    language: PropTypes.string.isRequired,
    text: PropTypes.string
  }))]),
  classes: PropTypes.shape({
    image: PropTypes.string,
    insideBottomLeft: PropTypes.string,
    insideBottomRight: PropTypes.string,
    insideContent: PropTypes.string,
    insideTopLeft: PropTypes.string,
    insideTopRight: PropTypes.string,
    left: PropTypes.string,
    middle: PropTypes.string,
    right: PropTypes.string,
    root: PropTypes.string
  }),
  className: PropTypes.string,
  mediaTypeComponents: PropTypes.shape({}),
  ProductImageProps: PropTypes.shape({}),
  shape: PropTypes.oneOf(['square', 'landscape', 'portrait', 'wide', 'tall']),
  shrink: PropTypes.oneOf(['crop', 'fit']),
  size: PropTypes.oneOf(['mini', 'small', 'normal', 'big']),
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))]),
  stream: PropTypes.string,
  type: PropTypes.string
};
ProductImageDecorated.defaultProps = {
  active: false,
  adornmentAsideLeft: undefined,
  adornmentAsideRight: undefined,
  adornmentInsideBottomLeft: undefined,
  adornmentInsideBottomRight: undefined,
  adornmentInsideTopLeft: undefined,
  adornmentInsideTopRight: undefined,
  alt: undefined,
  classes: undefined,
  className: undefined,
  mediaTypeComponents: undefined,
  ProductImageProps: undefined,
  shape: undefined,
  shrink: undefined,
  size: undefined,
  src: undefined,
  stream: undefined,
  type: undefined
};
export default ProductImageDecorated;